export const innerSymbolContainer = `<div id="innerSymbol">
                <div>Choose inner symbol: </div>
                <div class="symbol">
                    <div class="picked"></div>
                    <img/>
                </div>
            </div>`;
export const addRowContainer = `<div id="addRow">
                <div>Add/Remover row: </div>
                 <div class="symbol symbol-0">
                        <div class="picked"></div>
                         <img/>
                    </div>
                    <div class="symbol symbol-1">
                        <div class="picked"></div>      
                         <img/>
                    </div>
                    <div class="symbol symbol-2">
                        <div class="picked"></div>      
                         <img/>
                    </div>
                    <div class="symbol symbol-3">
                        <div class="picked"></div>   
                         <img/>   
                    </div>
                     <div class="symbol symbol-4">
                        <div class="picked"></div>   
                         <img/>   
                    </div>
                    <div>If dimension and reelsABC are selected - press "Apply" 
                    then choose symbols and press the "Apply" once more.</div>
            </div>`;
export const reelsABC = `<div id="errorContainer">This combination impossible</div>
                <div id="reelsABC">
                <div>Choose reels ABC for each reel: </div>
                <select id="reelsABC-0" class="reelsABCSelect">
                    <option selected>Random</option>
                    <option>0</option>
                    <option>1</option>
                </select>
                <select id="reelsABC-1" class="reelsABCSelect">
                    <option selected>Random</option>
                    <option>0</option>
                    <option>1</option>
                </select>
                <select id="reelsABC-2" class="reelsABCSelect">
                    <option selected>Random</option>
                    <option>0</option>
                    <option>1</option>
                </select>
                <select id="reelsABC-3" class="reelsABCSelect">
                    <option selected>Random</option>
                    <option>0</option>
                    <option>1</option>
                </select>
                <select id="reelsABC-4" class="reelsABCSelect">
                    <option selected>Random</option>
                    <option>0</option>
                    <option>1</option>
                </select>
            </div>`;
